export class AgendaEvents {
  constructor(state, elements) {
    this.state = state;
    this.elements = elements;
  }

  attachEvents() {
    document.addEventListener('navigation-bar-height', (e) => this.resizeHandler(e));
    window.addEventListener("scroll", () => this.syncFilterWithScroll());

    this.elements.filter.addEventListener("click", (e) =>
      this.handleFilterMonthClick(e)
    );

    this.elements.search.addEventListener("keyup", (e) => this.searchHandler(e));
    this.elements.categories?.addEventListener("change", (e) =>
      this.changeCategoryHandler(e)
    );
    this.elements.locations?.addEventListener("change", (e) =>
      this.changeLocationHandler(e)
    );
    this.elements.filterInner.addEventListener("scroll", (e) =>
      this.updateChevronVisibility(e)
    );
    this.elements.chevronLeft.addEventListener("click", () =>
      this.handleChevronClick("left")
    );
    this.elements.chevronRight.addEventListener("click", () =>
      this.handleChevronClick("right")
    );
  }

  resizeHandler(e) {
    this.state.set(
      "headerHeight",
      e.data
    );
  }

  searchHandler(e) {
    this.state.set("searchQuery", e.target.value);
  }

  changeCategoryHandler(e) {
    this.state.set("category", e.target.value);
  }

  changeLocationHandler(e) {
    this.state.set("location", e.target.value);
  }

  handleFilterMonthClick(e) {
    // Scroll to matching month in the agenda
    const month = e.target.closest(".agenda-overview-filter__month");
    if (!month) return;

    const monthToScrollTo = Array.from(this.elements.months).find(
      (item) =>
        item.dataset.month === month.dataset.month &&
        item.dataset.year === month.dataset.year
    );

    if (monthToScrollTo) {
      const headerHeightOffset = this.state.headerHeight || 0;
      const filterInnerOffset = this.elements.filterInner.offsetHeight || 0;
      const offset = headerHeightOffset + filterInnerOffset;
      const elementPosition =
        monthToScrollTo.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }

  handleChevronClick(direction) {
    // Scroll the filter to the previous or next month
    const firstVisibleMonth = Array.from(this.elements.filterMonths).find(
      (month) => {
        return (
          month.getBoundingClientRect().left >=
          this.elements.filterInner.getBoundingClientRect().left
        );
      }
    );

    const nextMonth =
      direction === "left"
        ? firstVisibleMonth.previousElementSibling
        : firstVisibleMonth.nextElementSibling;

    if (nextMonth) {
      this.elements.filterInner.scrollTo({
        left: nextMonth.offsetLeft - 20,
        behavior: "smooth",
      });
    }
  }

  syncFilterWithScroll() {
    // Scroll to the month in the filter that is currently visible in the agenda overview
    const firstVisibleMonth = Array.from(this.elements.months).find((month) => {
      const monthRect = month.getBoundingClientRect();
      const offset = 20;
      
      return (
        monthRect.top + month.offsetHeight - this.state.headerHeight - this.elements.filter.offsetHeight >= 0
        && monthRect.bottom - offset > this.state.headerHeight + this.elements.filter.offsetHeight
      );
    });

    if (firstVisibleMonth) {
      const filterMonthToHighlight = Array.from(
        this.elements.filterMonths
      ).find(
        (filterMonth) =>
          filterMonth.dataset.month === firstVisibleMonth.dataset.month &&
          filterMonth.dataset.year === firstVisibleMonth.dataset.year
      );

      if (filterMonthToHighlight) {
        this.elements.filterInner.scrollTo({
          left: filterMonthToHighlight.offsetLeft - 10,
          behavior: "smooth",
        });
      }
    }

    this.updateChevronVisibility();
  }

  updateChevronVisibility() {
    // If we are showing the first or last month in the filter, hide the corresponding chevron
    const offset = 30;
    const canScrollRight =
      this.elements.filterInner.scrollLeft + offset <
      this.elements.filterInner.scrollWidth -
        this.elements.filterInner.clientWidth;
    const canScrollLeft = this.elements.filterInner.scrollLeft > offset;

    this.elements.chevronLeft.style.opacity = canScrollLeft ? 1 : 0;
    this.elements.chevronRight.style.opacity = canScrollRight ? 1 : 0;
  }
}
